import React, { useMemo } from 'react'
import { Dayjs } from 'dayjs'
import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'
import { Card, Button, Space } from 'antd'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import { IDataByDay } from '../../model/selectors'
import { getDetailTaskItemData } from '../../model/services/getDetailTaskItemData'
import { TaskDetailCard } from '../task-detail-card'
import {
  Container,
  Header,
  Title,
  Grid,
  DayCardWrapper,
  DayHeader,
  DayName,
  DayNumber,
  DayContent,
  NoTasks
} from './styles'

dayjs.extend(isoWeek)

interface WeekViewProps {
  value: Dayjs
  dataByDay: IDataByDay
  isTimeTableViewMode: boolean
  onValueChange?: (newValue: Dayjs) => void
}

export const WeekView: React.FC<WeekViewProps> = ({
  value,
  dataByDay,
  isTimeTableViewMode,
  onValueChange,
}) => {
  const weekDays = useMemo(() => {
    const startOfWeek = value.startOf('isoWeek')
    return Array.from({ length: 7 }, (_, i) => startOfWeek.add(i, 'day'))
  }, [value])

  const today = dayjs()

  const handlePrevWeek = () => {
    const newValue = value.subtract(1, 'week')
    onValueChange?.(newValue)
  }

  const handleNextWeek = () => {
    const newValue = value.add(1, 'week')
    onValueChange?.(newValue)
  }

  const handleToday = () => {
    onValueChange?.(dayjs())
  }

  return (
    <Container>
      <Header>
        <Title>{value.format('MMMM YYYY')}</Title>
        <Space>
          <Button onClick={handleToday}>Сегодня</Button>
          <Button size='small' icon={<LeftOutlined />} onClick={handlePrevWeek} />
          <Button size='small' icon={<RightOutlined />} onClick={handleNextWeek} />
        </Space>
      </Header>
      <Grid>
        {weekDays.map((day) => {
          const isToday = day.isSame(today, 'day')
          const detailData = getDetailTaskItemData(day, dataByDay)

          return (
            <DayCardWrapper key={day.format('YYYY-MM-DD')} $isToday={isToday}>
              <Card
                title={
                  <DayHeader>
                    <DayName>{day.format('dd')}</DayName>
                    <DayNumber $isToday={isToday}>{day.format('D')}</DayNumber>
                  </DayHeader>
                }
                bordered
              >
                <DayContent>
                  {detailData && detailData.length > 0 ? (
                    detailData.map((task) => (
                      <TaskDetailCard key={task.id} task={task} compact />
                    ))
                  ) : (
                    <NoTasks>Нет задач</NoTasks>
                  )}
                </DayContent>
              </Card>
            </DayCardWrapper>
          )
        })}
      </Grid>
    </Container>
  )
}

